var map = {
	"./albergolosone.jpg": 105,
	"./alpina.jpg": 106,
	"./ameronswissmountain.jpg": 107,
	"./artdecomontana.jpg": 108,
	"./arthotel_riposo.jpg": 109,
	"./atlantis.jpg": 110,
	"./backstage-vernissage.jpg": 111,
	"./badrutt-s-palace.jpg": 112,
	"./baur-au-lac.jpg": 113,
	"./beatus.jpg": 114,
	"./beaurivage.jpg": 115,
	"./beaurivagepalace.jpg": 116,
	"./bodmi.jpg": 117,
	"./buergenstock.jpg": 118,
	"./castello_del_sole.jpg": 119,
	"./chedi.jpg": 120,
	"./de_rougemont.jpg": 121,
	"./doldenhorn.jpg": 122,
	"./dolder-grand.jpg": 123,
	"./eden-roc.jpg": 124,
	"./ermitage.jpg": 125,
	"./fairmontlemontreux.jpg": 126,
	"./fourseasons.jpg": 127,
	"./fruttfamilylodge.jpg": 128,
	"./giardino.jpg": 129,
	"./ginabelle.jpg": 130,
	"./grandhotelquellenhof.jpg": 131,
	"./gstaad_palace.jpg": 132,
	"./hof_weissbad.jpg": 133,
	"./huus-gstaad.jpg": 134,
	"./kempinski.jpg": 135,
	"./kulm.jpg": 136,
	"./la-reserve-geneve.jpg": 137,
	"./le-grand-bellevue.jpg": 138,
	"./lenkerhof.jpg": 139,
	"./lestroisrois.jpg": 140,
	"./maerchenhotelbraunwald.jpg": 141,
	"./mandarinoriental.jpg": 142,
	"./nira-alpina.jpg": 143,
	"./pirmin_zurbriggen.jpg": 144,
	"./placeholder.jpg": 145,
	"./priva.jpg": 146,
	"./radissonblue.jpg": 147,
	"./rockresort.jpg": 148,
	"./romantik-hotel-julen-zermatt.jpg": 149,
	"./saratzt.jpg": 150,
	"./schweizerhof.jpg": 151,
	"./schweizerhofbern.jpg": 152,
	"./spitzhorn.jpg": 153,
	"./suvretta-house.jpg": 154,
	"./swiss_holiday_park.jpg": 155,
	"./thehide.jpg": 156,
	"./tschuggen.jpg": 157,
	"./ultima-gstaad.jpg": 158,
	"./valbellainn.jpg": 159,
	"./victoriajungfrau.jpg": 160,
	"./vitznauerhof.jpg": 161,
	"./wellnesshotelgolfpanorama.jpg": 162,
	"./widder.jpg": 163
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | placeholder */ 60).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 67;
module.exports = webpackAsyncContext;